import { Select, styled } from '@mui/material';
import {
  BaseStyledMenuItem,
  checkboxStyles,
  ClearIconWrapper,
  createFilterWrapper,
  displayLabelStyles,
  getSelectStyles,
  HoverOverlay,
  StyledClearIcon,
} from '../FilterStyles';

export { HoverOverlay, ClearIconWrapper, StyledClearIcon, displayLabelStyles, checkboxStyles, getSelectStyles };

export const FilterWrapper = createFilterWrapper('default');
export const StyledMenuItem = BaseStyledMenuItem;

export const StyledSelect = styled(Select)(({ theme }) => ({
  position: 'relative',
  fontSize: 16,
  zIndex: 1,

  '& .MuiSelect-standard': {
    paddingLeft: theme.spacing(1),
    borderRadius: theme.shape.borderRadius / 2,
    maxWidth: 180,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '& .MuiSelect-icon': {
    color: 'gray',
    marginRight: 0,
  },
}));

export const searchBoxWrapperStyles = {
  px: 2,
  py: 1,
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

export const searchTextFieldStyles = {
  '& .MuiOutlinedInput-root': {
    fontSize: 16,
    borderRadius: 0.5,
  },
};

export const getPaperPropsStyles = (enableSearch: boolean) => ({
  minWidth: `200px !important`,
  maxWidth: 230,
  maxHeight: enableSearch ? 250 : 200,
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
});
